<template>
    <div class="tw-relative">
        <div class="tw-absolute tw-left-2 tw-top-0 -tw-mt-0.5 tw-text-xs tw-text-red-500">
            <slot />
        </div>
    </div>
</template>
